/**
 * RTK Query endpoint — global semantic search
 *
 * Hits the backend `GET /search` (permission-aware hybrid semantic search over
 * the media-embeddings index). Returns results grouped by category
 * (inspection / resource / item), each with tags, image/video/sound flags, a
 * relevance score and a snippet. Auth + X-Tenant-Id are attached by baseApi.
 */

import { baseApi } from './baseApi';

const searchApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    search: builder.query({
      query: ({ q, perGroup, categories, mediaTypes, lang }) => {
        const params = {};
        if (q != null && q !== '') params.q = q;
        if (perGroup != null) params.perGroup = perGroup;
        if (categories && categories.length) params.categories = categories.join(',');
        if (mediaTypes && mediaTypes.length) params.mediaTypes = mediaTypes.join(',');
        // Searcher's language → same-language semantic matching (see backend).
        if (lang) params.lang = lang;
        return { url: '/search', method: 'GET', params };
      },
      providesTags: ['Search'],
      // Dedup rapid typing without staling.
      keepUnusedDataFor: 60,
    }),
  }),
  overrideExisting: false,
});

export const { useSearchQuery, useLazySearchQuery } = searchApi;
export default searchApi;
